import React, { useRef, useState, useEffect, useCallback } from 'react'
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';

import { Alert, Autocomplete, AvatarGroup, Checkbox, Container, Fade, FormControlLabel, FormGroup, Icon, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
// import Sidebar from '../Sidebar'

import { AiOutlineClose } from "react-icons/ai";


// Importaciones para el modal
import { Button, Modal, Box, Typography, TextField, Tabs, Tab, Divider, Switch, Card, Avatar, IconButton, Chip } from '@mui/material';


// Iconos
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import PublicIcon from '@mui/icons-material/Public';
import HttpsIcon from '@mui/icons-material/Https';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Tres puntos horizontales
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import CircleIcon from '@mui/icons-material/Circle';
import Diversity3Icon from '@mui/icons-material/Diversity3';

// Date y time pickers
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es'; // Importa el idioma español
import { DesktopDatePicker, MobileTimePicker, StaticDateTimePicker, StaticTimePicker } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';


// Componentes de JOY UI
import { AspectRatio, Input, Textarea } from '@mui/joy';
import CateringCard from '../../components/Cards/CateringCard';
import Header from '../../components/Header';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import axios from 'axios';
import { connect } from 'react-redux';
import CryptoJS from "crypto-js";
import { FaShareAlt } from 'react-icons/fa';
import { LoadScript, GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import MapWithAutocomplete from '../../components/maps';
import { AdvancedMarker, APIProvider, Map, Pin } from '@vis.gl/react-google-maps';
import { CheckBox } from '@mui/icons-material';
// import { Autocomplete } from '@react-google-maps/api'; // Asegúrate de importar correctamente el componente Autocomplete
import imageCompression from 'browser-image-compression';
// API KEY DE GOOGLE MAPS: AIzaSyChMjunVgwjwuS1zjbnchasW8zj5OSXCvc


const mapStateToProps = (state) => {
  return {
    page: state.pageReducer.pageName,
    user: state.userReducer,
    eventModalState: state.modalReducer.eventModalState,
    guestsModalState: state.modalReducer.guestsModalState,
    token: state.tokenReducer.token
  }
}


const Maps = ({ defaultCenter, initialCoords, onLocation }) => {
  // Estado para almacenar el centro inicial del mapa
  const [initialMapCenter, setInitialMapCenter] = useState(defaultCenter);
  // Estado para controlar el centro actual del mapa
  const [mapCenter, setMapCenter] = useState(defaultCenter);

  // Función para restablecer el centro del mapa a la posición inicial
  const handleResetCenter = () => {
    setMapCenter(initialMapCenter);
  };

  // Función que se ejecuta cuando el usuario mueve el mapa
  const handleCameraChanged = (ev) => {
    const newCenter = ev.detail.center;
    setMapCenter(newCenter); // Actualiza el centro actual del mapa
    onLocation(newCenter); // Llama a la función onLocation con el nuevo centro
  };

  return (
    <APIProvider>
      <div style={{ position: 'relative' }}>
        <Map
          style={{ width: '100%', height: 300 }}
          center={mapCenter} // Usamos el estado para controlar el centro del mapa
          defaultZoom={15}
          gestureHandling={'greedy'}
          disableDefaultUI={true}
          onCameraChanged={handleCameraChanged} // Escucha los cambios en la cámara
          mapId='AIzaSyAv2gmZYl03K-EsNmKwOF0rNhO1YMrvj5Q'
        >
          <PoiMarkers pois={[{ key: 'location', location: { lat: initialCoords.lat, lng: initialCoords.lng } }]} />
        </Map>
        {/* Botón para restablecer el centro del mapa */}
        <IconButton
          onClick={handleResetCenter}
          style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}
        >
          <RestartAltIcon />
        </IconButton>
      </div>
    </APIProvider>
  );
};

const PoiMarkers = (props) => {
  return (
    <>
      {props.pois.map((poi) => (
        <AdvancedMarker
          key={poi.key}
          position={poi.location}
        >
          <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'} />
        </AdvancedMarker>
      ))}
    </>
  );
};


const JuntadaComun = (props) => {
  let [publicKey, setPublicKey] = useState('');
  let statePublicKey = '';
  let [privateKey, setPrivateKey] = useState('');
  let statePrivatecKey = '';

  const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false); // Estado para la pantalla de carga
  let [openModalAddGuests, setOpenModalAddGuests] = useState(false)
  // const mapRef = useRef(null);

  const fileInputRef = useRef(null);
  let stateEventCreadoID = "";
  let [eventCreadoID, setEventCreadoID] = useState('')

  // VARIABLES PRIMERA PARTE
  const [eventName, setEventName] = useState('')
  let [eventDescription, setEventDescription] = useState('')
  let [guardarEstadoEventDescription, setGuardarEstadoEventDescription] = useState("")
  const [eventImage, setEventImage] = useState('')
  const [eventImageBlob, setEventImageBlob] = useState('')

  let [eventLocation, setEventLocation] = useState('')
  let [eventCoords, setEventCoords] = useState('')
  let [inicialEventCoords, setInicialEventCoords] = useState('')
  let [avatar, setAvatar] = useState('')

  let [friends, setFriends] = useState([]);

  let [searchFriends, setSearchFriends] = useState('')

  const filteredFriends = friends.filter(friend =>
    friend.nameUser.toLowerCase().includes(searchFriends.toLowerCase())
  );



  // const [selectedDate, setSelectedDate] = useState('')
  const [selectedDate, setSelectedDate] = useState(null)

  const [valuee, setValuee] = React.useState(dayjs('2022-04-17'));
  const [traducedDate, setTraducedDate] = useState(null)

  const [selectedHour, setSelectedHour] = useState(null)
  const [traducedHour, setTraducedHour] = useState(null)

  let [eventTypeManual, setEventTypeManual] = useState('') // Tipo de Evento

  let [eventTypeAuto, setEventTypeAuto] = useState(null) // Tipo de Evento

  let [eventPrivacity, setEventPrivacity] = useState(true) // Tipo de Evento

  let [guests, setGuests] = useState([ // Aca se almacenaran los usuarios invitados
  ])

  let [selectedGuest, setSelectedGuest] = useState(null) // Aca se almacenaran los datos del usuario a invitar

  let [eventCaracteristics, setEventCaracteristics] = useState('')
  let [guardarEstadoEventCaracteristics, setGuardarEstadoEventCaracteristics] = useState("")
  const [guestsView, setGuestsView] = useState(false)

  const [eventCreator, setEventCreator] = useState('')

  // VARIABLES PARA TIPO DE PRIVACIDAD
  const [indexEventPrivacity, setIndexEventPrivacity] = useState(0)

  const [showAlert, setShowAlert] = useState(false)
  let [alertMsg, setAlertMsg] = useState('')


  let [locationValid, setLocationValid] = useState(true)
  const [checked, setChecked] = React.useState(true);


  // LISTADO DE USUARIOS DISPONIBLES PARA INVITAR AL EVENTO A CREAR
  const [availableUsers, setAvailableUsers] = useState([]);

  const eventTypes = [
    'No definido',
    'Cumpleaños',
    'Reunión Laboral Virtual',
    'Reunión Laboral Presencial',
    'Casamiento',
    'Viaje',
    'Juntada común',
    'Club Nocturno',
    'Fiesta Nacional',
    'Funcion Teatral',
    'Show musical',
    'Evento al aire libre',
    'Evento Virtual',
  ];



  // FUNCION PARA CREAR EL EVENTO FINALMENTE
  async function CreateNewEvent() {




    // VALIDACION DATOS OBLIGATORIOS
    if (eventName == '' || selectedDate == null || traducedHour == null || locationValid == false) {
      const regex = /^\d{2}\/\d{2}\/\d{4}$/;
      let errores = ''
      setShowAlert(true)

      if (eventName == '') {
        errores += ' | Nombre del evento '
      }

      if (selectedDate == null) {
        errores += ' | Fecha de Inicio '
      }
      // else if (!regex.test(selectedDate)) {
      //     errores += ' | Fecha de Inicio válido '
      // }

      if (traducedHour == null) {
        errores += ' | Hora de Inicio '
      }

      if (locationValid == false) {
        errores += ' | Ubicación correcta '
      }

      setAlertMsg(errores)

    } else {


      let eventType = ''
      let privacity = ''
      if (eventPrivacity === true) {
        privacity = 'PRIVADO'
      } else {
        privacity = 'PUBLICO'
      }

      if (eventTypeAuto !== null) {
        eventType = eventTypeAuto
      } else {
        eventType = eventTypeManual
      }


      try {
        setLoading(true); // Mostrar pantalla de carga
        // const formData = new FormData();
        // formData.append('file', eventImage);

        let compressedFile;
        var imageUrl = "";
        // let formData = new FormData();

        if (eventImageBlob) {

          const options = {
            maxSizeMB: 1, // Tamaño máximo en MB
            maxWidthOrHeight: 1024, // Resolución máxima
            useWebWorker: true, // Usar Web Worker para mejor rendimiento
            fileType: 'image/webp', // Convertir a WebP
          };

          try {
            compressedFile = await imageCompression(eventImageBlob, options);
            imageUrl = await uploadImageToBackend(compressedFile);
            // formData.append('file', compressedFile);
          } catch (error) {
            console.error('Error comprimiendo la imagen:', error);
          }
        }


        let guestsTraduccion = ""
        // console.log(guests)
        friends.map((item, index) => {
          if (item.selected == true) {
            guestsTraduccion += item.userID + "; "
          }
        })


        const headers = 'content-type: application/json; charset=utf-8'
        const token = localStorage.getItem('jwt_token');


        var userData = JSON.parse(localStorage.getItem('userData'))

        console.log("eventCoords")
        console.log(eventCoords)
        if (typeof eventCoords !== 'string') {
          eventCoords = JSON.stringify(eventCoords)
        }

        const data = {
          "eventType": "Juntada Comun",
          "creatorAvatar": JSON.parse(localStorage.getItem('userData')).avatar,
          "eventTitle": eventName,
          "creatorId": JSON.parse(localStorage.getItem('userData')).userID,
          "guestsId": guestsTraduccion,
          "creatorName": props.user.nombre,
          "eventDescription": eventDescription,
          "startDay": selectedDate,
          "startHour": traducedHour,
          "eventLocation": eventLocation,
          "eventLocationCoords": eventCoords.includes("lat") ? eventCoords : "",
          "eventPrivacity": privacity,
          "eventImage": imageUrl,
          "eventCharacteristics": eventCaracteristics
        }

        console.log("data")
        console.log(data)

        // const jsonData = JSON.stringify(data);
        // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        await axios.put('https://socializeapi.azurewebsites.net/api/CreateEvent', data, {
          headers
        })
          .then(response => {
            enviarnotificacionCreatedEvent(data)

            setEventName('')
            setEventDescription('')
            setEventLocation('')
            setSelectedDate('')
          })
          .catch(error => {
            console.log(`Error obteniendo datos: ${error}`);
            if (error == "AxiosError: Request failed with status code 401") {
              navigate("/login")
              alert("Sesión caducada!")
            }
          });


        // store.dispatch(CREATE_EVENT_action({name: eventName, description: eventDescription, image: eventImage}))


      } catch (error) {
        console.log(`Error obteniendo datos: ${error}`);
      } finally {
        setLoading(false); // Ocultar pantalla de carga
        await obtenerDatosEventoCreado()
        if (privacity == "PRIVADO") {
          setOpenModalAddGuests(true);
        } else {
          setOpenModalAddGuests(false);
          navigate('/');
        }
      }




    }
  }

  async function getAvatar() {
    const data = {
      "UserID": props.user.id,
    }
    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'

    await axios.post('https://socializeapi.azurewebsites.net/api/GetAvatar', { data: data_encripted }, {
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      responseType: 'blob'
    })
      .then(response => {
        const imageUrl = URL.createObjectURL(response.data);

        console.log("imageUrl")
        console.log(imageUrl)
        setAvatar(imageUrl)
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  const uploadImageToBackend = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch('https://socializeapi.azurewebsites.net/api/upload', {
      method: 'POST',
      body: formData,
    });

    console.log("uploadImageToBackend")
    console.log(response)

    if (response.ok) {
      const data = await response.json(); // Obtener la URL de la respuesta
      console.log('Imagen subida con éxito. URL:', data.url);
      return data.url; // Retornar la URL para asociarla al evento
    } else {
      console.error('Error subiendo la imagen');
      throw new Error('Error al subir la imagen')
    }
  };




  async function enviarnotificacionCreatedEvent(eventData) {
    let guestsTraduccion = ""
    // console.log(guests)
    friends.map((item, index) => {
      if (item.selected == true) {
        guestsTraduccion += item.userID + "; "
      }
    })

    const headers = 'content-type: application/json; charset=utf-8'
    await obtenerVAPID()

    const data = {
      "privateKey": statePrivatecKey,
      "publicKey": statePublicKey,
      "userAgent": navigator.userAgent,
      "invitedUsers": guestsTraduccion,
      "eventData": eventData,
      "action": "createevent"
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



    await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
      headers
    })
      .then(response => {
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      });
  }


  async function obtenerVAPID() {
    const headers = 'content-type: application/json; charset=utf-8'

    await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
      .then(response => {
        if (response.data !== null) {
          setPublicKey(response.data.value.keys.publicKey)
          statePublicKey = response.data.value.keys.publicKey
          setPrivateKey(response.data.value.keys.privateKey)
          statePrivatecKey = response.data.value.keys.privateKey
        }

      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  // Agregar estilos globales al scrollbar
  const customScrollbarStyles = `
::-webkit-scrollbar {
  width: 10px;
}


::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`;

  // FUNCION PARA CAMBIAR LA PRIVACIDAD DEL EVENTO
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const changeEventPrivacity = (event, newValue) => {
    setIndexEventPrivacity(newValue);
  };



  // FUNCION PARA TRADUCIR LA HORA DEL EVENTO
  const traduceSelectedHour = (time) => {

    setSelectedHour(time)
    const fecha = new Date(time);
    const options = { hour: '2-digit', minute: '2-digit', hour12: false };
    const fechaEnEspanol = fecha.toLocaleDateString('es-ES', options);

    let fecha2 = fechaEnEspanol;
    fecha2 = fecha2.replace(/^[^,]*,\s*/g, '');
    setTraducedHour(fecha2);
  }

  const handleGetLocationFromChild = (location) => {
    console.log("Entra al padre");
    console.log("Ubicación obtenida:", location);
    if (location.split("|")[0] == "Auto") {
      console.log(JSON.parse(location.split("|")[1]));

      setEventCoords(JSON.parse(location.split("|")[1]))
      setInicialEventCoords(JSON.parse(location.split("|")[1]))
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: JSON.parse(location.split("|")[1]) }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            console.log("Dirección encontrada:", results[0].formatted_address);
            setLocationValid(true);
          } else {
            console.log("No se encontraron resultados.");
            setLocationValid(false);
          }
        } else {
          console.error("Fallo en la geocodificación inversa: " + status);
          setLocationValid(false);
        }
      });
      setLocationValid(true);
    } else {
      if (location == "" || location == "Manual|") {

        setLocationValid(true);
      } else {
        setLocationValid(false);
      }
    }

    // setEventLocation(location)

    // alert(`Ubicación obtenida: Latitud: ${location.lat}, Longitud: ${location.lng}`);
  };

  const onChangeLocation = (location) => {
    // console.log(location)
    // setEventLocation(location)
    console.log("2 paso")
    console.log(location)
    setEventCoords(location)
  };

  const InputLock = styled('input')({
    display: 'none'
  });

  const BtnLock = styled('label')(({ eventPrivacity }) => ({
    // position: 'absolute',
    top: 'calc(50% - 32px)',
    left: 'calc(50% - 32px)',
    display: 'inline-block',
    background: (eventPrivacity ? '#ff5b5b' : '#20cca5'),
    width: 64,
    height: 64,
    boxSizing: 'border-box',
    padding: '12px 0 0 18px',
    borderRadius: '50%',
    cursor: 'pointer'
  }));

  const SvgLock = styled('svg')({
    fill: 'none',
    transform: 'translate3d(0, 0, 0)'
  });

  const BlingPath = styled('path')(({ props }) => ({
    stroke: '#fff',
    strokeWidth: 2.5,
    strokeLinecap: 'round',
    strokeDasharray: 3,
    strokeDashoffset: 15,
    transition: 'all 0.3s ease',
    animationName: 'bling6132',
    animationDuration: '0.3s',
    animationTimingFunction: 'linear',
    animationFillMode: 'forwards',
    animationDelay: '0.2s'
  }));

  const LockPath = styled('path')(({ eventPrivacity }) => ({
    stroke: '#fff',
    strokeWidth: 4,
    strokeLinejoin: 'round',
    strokeLinecap: 'round',
    strokeDasharray: (eventPrivacity ? 48 : 36),
    transition: 'all 0.4s ease',
    animationName: 'locked',
    animationDuration: '0.3s',
    animationTimingFunction: 'linear',
    animationFillMode: 'forwards'
  }));

  // const LockBPath = styled('path')({
  //     fill: '#fff',
  //     fillRule: 'evenodd',
  //     clipRule: 'evenodd',
  //     transform: 'rotate(8deg)',
  //     transformOrigin: '14px 20px',
  //     transition: 'all 0.2s ease'
  // });


  const LockBPath = styled('path')(({ eventPrivacity }) => ({
    fill: '#fff',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    transform: (eventPrivacity ? 'rotate(0deg)' : 'rotate(8deg)'),
    transformOrigin: '14px 20px',
    transition: 'all 0.2s ease'
  }));

  const [file, setFile] = useState()

  const handleImageUpload = (e) => {
    setFile(e.target.files[0])
    // Guardar el archivo en el estado local o realizar otras operaciones
  };

  const [value, setValue] = useState(null);

  const handleOnChange = (event, newValue) => {
    // console.log(newValue)
    setValue(newValue);
  };

  const getOptionLabel = (option) => {
    if (typeof option === 'string') {
      return option;
    }
    if (option instanceof String) {
      return option.toString();
    }
    return option.label;
  };

  function decryptData(encryptedText) {
    // Define la misma clave que usaste en el backend
    const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

    // Decodifica el texto encriptado de base64
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

    // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
    const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
    const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

    // Deriva la clave usando SHA256
    const hashedKey = CryptoJS.SHA256(key);

    // Desencripta el contenido
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedContent },
      hashedKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Convierte el resultado a texto legible
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  const handleCheckboxChange = (index) => {
    setFriends(prevFriends => {
      const updatedFriends = [...prevFriends];
      updatedFriends[index].selected = !updatedFriends[index].selected;
      return updatedFriends;
    });
  };

  // EFFECTS

  useEffect(() => {
    if (!props.token) {
      console.log("el token no es valido")
      navigate("/")
    } else {
      setSelectedDate(null)
      getFriends();
      getAvatar();
    }
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768); // set the breakpoint here
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  async function getFriends() {
    const token = localStorage.getItem('jwt_token');

    var data = {
      userID_1: props.user.id
    }

    // const jsonData = JSON.stringify(data);
    // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'
    console.log("getFriends")
    await axios.post(`https://socializeapi.azurewebsites.net/api/getfriends`, data, {
      headers
    })
      .then(response => {

        const friendsWithSelected = response.data.map(friend => {
          return {
            ...friend,
            selected: false // Puedes establecer el valor inicial que desees, en este caso 'false'
          };
        });

        setFriends(friendsWithSelected)
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      })
  }

  const uploadImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Realizar la conversión de la imagen al formato necesario (base64)
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setEventImage(base64String)
        // Enviar la imagen al endpoint a través de una petición a SQL
        // Aquí se realizaría la lógica para enviar la imagen en formato base64 a la base de datos
      };
      setEventImageBlob(file)
      reader.readAsDataURL(file);
    }
  };



  async function obtenerDatosEventoCreado() {

    const data = {
      "eventID": -1,
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();


    const token = localStorage.getItem('jwt_token');
    const headers = 'content-type: application/json; charset=utf-8'
    await axios.post(`https://socializeapi.azurewebsites.net/api/GetEvent`, { data: data_encripted }, {
      headers
    })
      .then(response => {
        let decripted_response = decryptData(response.data)

        // Convertir el string a un objeto
        const responseObject = JSON.parse(decripted_response);

        console.log("responseObject.EventID")
        console.log(responseObject.EventID)
        const encrypted = CryptoJS.AES.encrypt(responseObject.EventID.toString(), "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        setEventCreadoID(encrypted);

      })
      .catch(error => {
        console.log(`Error obteniendo los eventos: ${error}`);
      })
  }

  const handleShare = async () => {
    console.log("eventCreadoID")
    console.log(eventCreadoID)
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Invitación',
          text: 'Únete al evento en nuestra página',
          url: `https://hisocialize.netlify.app/registro?data=${encodeURIComponent(eventCreadoID)}`,
        });
        console.log('Compartido con éxito');
      } catch (error) {
        console.error('Error al compartir:', error);
      }
    } else {
      alert('La función de compartir no está disponible en este dispositivo.');
    }
  };

  // Estilos en línea como objetos de JavaScript
  const styles = {
    loadingScreen: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    loadingModal: {
      backgroundColor: 'white',
      padding: '20px 30px',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      textAlign: 'center',
    },
    loadingSpinner: {
      margin: '20px auto',
      width: '40px',
      height: '40px',
      border: '4px solid transparent',
      borderTop: '4px solid #3498db',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
  };

  return (
    <div>
      <Header actualPage={'createevent'}></Header>
      <div style={{
        display: 'flex',
        width: '100%',
      }}>
        {loading && (
          <div className="loading-screen">
            <div className="loading-modal">
              <p>Creando evento, por favor espere...</p>
              <div className="loading-spinner"></div>
            </div>
          </div>
        )}

        {/* <Sidebar></Sidebar> */}
        <Container maxWidth="sm">
          {/* <Box sx={{ bgcolor: '#cfe8fc', height: '100vh' }} /> */}
          <div style={{ width: '100%', height: '100%' }}>


            {/* HEADER */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 64, marginTop: 64 }}>


              <Typography color='#2196F3' variant={isLargeScreen ? 'h3' : 'h5'} marginTop={4} style={{ marginInline: 'auto' }}>
                Crea un nuevo Evento
              </Typography>


              {/* <p style={{ fontSize: 32, color: '#2196F3' }}>Crear Evento</p> */}
            </div>

            {/* BODY */}
            <div>

              {/* IMAGEN DEL EVENTO */}
              <div >
                {eventImage && (

                  <img src={eventImage} alt=""
                    style={{
                      width: '100%',
                      height: isLargeScreen ? 300 : 200,
                      borderRadius: 20,
                      objectFit: 'cover'
                    }}
                  />

                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <IconButton size='large' style={{ backgroundColor: '#3d5afe' }}>
                    <input
                      type="file"
                      accept="image/*"
                      style={{
                        position: 'absolute',
                        opacity: 0,
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                      }}
                      ref={fileInputRef}
                      onChange={(event) => { uploadImage(event) }}
                    />

                    <CameraAltIcon style={{ color: 'white' }}></CameraAltIcon>
                  </IconButton>

                  {eventImage && (
                    <IconButton size='large' style={{ backgroundColor: '#f44336', marginLeft: 16 }} onClick={() => { setEventImage(''); setEventImageBlob(''); fileInputRef.current.value = '' }}>
                      <CloseIcon style={{ color: 'white' }}></CloseIcon>
                    </IconButton>
                  )}
                </div>

                <div style={{ width: '100%', textAlign: 'center' }}>
                  <Typography fontFamily={'Fredoka, sans-serif'}>Subir una imagen</Typography>
                </div>


              </div>


              {/* NOMBRE, DESCRIPCION E IMAGEN */}
              {/* <div style={{ width: '100%', textAlign: 'center' }}>
                <Typography fontFamily={'Fredoka, sans-serif'} variant='h5' style={{ color: 'grey', marginBottom: 16, marginTop: 64 }}>Datos Básicos</Typography>
              </div> */}

              <div style={{ display: (isLargeScreen ? 'flex' : null), flexDirection: 'column', flexGrow: 1, gap: 16, borderRadius: '2rem', marginTop: 64 }}>

                {/* NOMBRE Y DESCRIPCION DEL EVENTO */}

                <div style={{ width: '100%', textAlign: 'center' }}>
                  <EventNoteIcon style={{ color: '#5c6bc0' }} />
                </div>

                <div style={{ marginBottom: 8, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', gap: 16 }}>

                  <input
                    type="text"
                    placeholder="Nombre del Evento (obligatorio)"
                    style={{
                      boxSizing: `border-box`,
                      border: `1px solid transparent`,
                      width: `100%`,
                      height: `40px`,
                      padding: `0 12px`,
                      borderRadius: `3px`,
                      boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                      fontSize: `14px`,
                      textAlign: 'center',
                      outline: `none`,
                      textOverflow: `ellipses`,
                    }}
                    aria-multiline
                    value={eventName}
                    onChange={(event) => { setEventName(event.target.value) }} />
                </div>


              </div>



              {/* UBICACION */}
              {/* <div style={{ width: '100%', textAlign: 'center',marginTop: 16 }}>

                <Typography fontFamily={'Fredoka, sans-serif'} variant='h5' style={{ color: 'grey', marginBottom: 16 }}>¿Dónde y Cuándo?</Typography>
              </div> */}

              <div style={{ display: (isLargeScreen ? 'flex' : null), marginTop: 16 }}>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: 16, marginBottom: 16 }}>
                  <ModeOfTravelIcon style={{ color: '#5c6bc0' }}></ModeOfTravelIcon>
                </div>


              </div>
              {eventCoords !== '' ?
                <div>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Button variant='contained' style={{ marginBottom: 16, marginInline: 'auto' }} onClick={() => { setEventCoords(''); setEventLocation('') }}>Cambiar ubicación</Button>
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Maps
                      defaultCenter={{ lat: eventCoords.lat, lng: eventCoords.lng }}
                      onLocation={onChangeLocation} // el valor se onLocation se deposita en onChangeLocation (es para ajustar la ubicacion)
                      initialCoords={inicialEventCoords}
                    ></Maps>
                    <CircleIcon style={{ position: 'absolute', color: '#f44336', top: isLargeScreen ? 'calc(50% - 4px)' : 'calc(150px - 4px)', left: isLargeScreen ? 'calc(50% - 4px)' : 'calc(50% - 4px)', fontSize: 8 }}></CircleIcon>
                  </div>
                </div>
                :
                <MapWithAutocomplete onGetLocationCoords={handleGetLocationFromChild} onGetLocation={(e) => { setEventLocation(e) }}></MapWithAutocomplete>
              }


              {/* FECHA Y HORA */}
              {isLargeScreen ? (
                <div style={{ display: 'flex', minWidth: '100%', width: (isLargeScreen ? '50%' : '100%'), gap: 16, marginBottom: 64 }}>
                  {/* Icono Reloj */}
                  {/* <MdAccessTime style={{ display: (isLargeScreen ? null : 'none'), marginLeft: 'auto', marginRight: 16, marginTop: 12 }} color='grey' size='32' /> */}


                  {/* HORA */}
                  <div style={{ width: '100%' }}>
                    <Typography style={{ marginBottom: 8, color: 'grey' }}>Horario de Inicio (Oblitagorio)</Typography>

                    <div style={{ marginTop: -8 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <MobileTimePicker value={selectedHour} onChange={(event) => { traduceSelectedHour(event) }} defaultValue={dayjs('2022-04-17T15:30')} sx={{ width: '100%' }} />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>

                  {/* INPUTS FECHA */}
                  <div style={{ marginBottom: (!isLargeScreen && 32), width: '100%' }}>
                    <Typography style={{ marginBottom: 8, color: 'grey' }}>Fecha de Inicio (Oblitagorio)</Typography>

                    <div style={{ marginTop: -8 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker label="DD/MM/AAAA" value={selectedDate} onChange={(event) => { setSelectedDate(event) }} sx={{ width: '100%' }} />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>


                </div>
              ) : (
                <>
                  {/* HORA */}
                  <div style={{ width: '100%', marginBottom: 16 }}>
                    <Typography style={{ marginBottom: 8, color: 'grey' }}>Horario de Inicio</Typography>

                    <div style={{ marginTop: -8 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <MobileTimePicker value={selectedHour} onChange={(event) => { traduceSelectedHour(event) }} defaultValue={dayjs('2022-04-17T15:30')} sx={{ width: '100%' }} />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>

                  {/* INPUTS FECHA */}
                  <div style={{ marginBottom: 64, width: '100%' }}>
                    <Typography style={{ marginBottom: 8, color: 'grey' }}>Fecha de Inicio</Typography>

                    <div style={{ marginTop: -8 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker label="DD/MM/AAAA" value={selectedDate} onChange={(event) => { setSelectedDate(event) }} sx={{ width: '100%' }} />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </>

              )}





              {/* DETALLES DEL EVENTO */}

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 8 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 24 }}>
                  <InfoIcon style={{ color: '#5c6bc0', fontSize: 32 }} />
                  <Typography variant='h5' fontFamily={'Fredoka, sans-serif'} color={'grey'} style={{ textAlign: 'center' }}>Información importante</Typography>
                </div>
                <div style={{ borderRadius: '2rem' }}>
                  <TextField multiline
                    value={eventCaracteristics}
                    onChange={(event) => { setEventCaracteristics(event.target.value) }}
                    style={{ width: '100%' }}>
                  </TextField>
                </div>
              </div>

              {/* <div ref={mapRef} style={{ width: '100%', height: '400px' }} /> */}


              {/* TIPO DE PRIVACIDAD */}
              <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', marginTop: 64 }}>
                <Diversity3Icon style={{ color: '#5c6bc0' }}></Diversity3Icon>
                <Typography fontFamily="Fredoka, sans-serif">Amigos</Typography>
              </div>
              {/* {eventPrivacity ? (
                <Typography fontSize={12} style={{ color: '#ff5b5b', marginBottom: 16, textAlign: 'center' }}>(Privado: Solo usted y los usuarios que invite podrán ver este Evento).</Typography>
              ) : (
                <Typography fontSize={12} style={{ color: '#20cca5', marginBottom: 16, textAlign: 'center' }}>(Público: Todos los que entren HiSocialize verán este Evento).</Typography>
              )} */}

              {/* <div style={{ marginTop: 32 }}>
                {eventPrivacity ? ( // privado

                  <div style={{ textAlign: 'center' }}>
                    <IconButton style={{ backgroundColor: '#ffe0b2' }}>
                      <HttpsIcon style={{ color: '#ff9100', fontSize: 72 }}></HttpsIcon>
                    </IconButton>
                    <Typography color={'#ff9100'} fontFamily="Fredoka, sans-serif">Privado</Typography>
                  </div>

                ) : ( // publico

                  // ESTO QUEDA INHABILITADO
                  <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <IconButton style={{ backgroundColor: '#838fcf' }} onClick={() => { setEventPrivacity(!eventPrivacity) }}>
                      <PublicIcon style={{ color: '#3f51b5', fontSize: 72 }}></PublicIcon>
                    </IconButton>
                    <Typography color={'primary'} fontFamily="Fredoka, sans-serif">Público</Typography>
                  </div>

                )}
              </div> */}




              {/* INVITACIONES */}
              {eventPrivacity && (
                <>
                  {friends.length > 0 ? (
                    <div style={{ marginBottom: 32 }}>

                      <TextField
                        size='small'
                        fullWidth
                        placeholder='Buscar'
                        value={searchFriends}
                        onChange={(e) => { setSearchFriends(e.target.value) }}>


                      </TextField>

                      <style>{customScrollbarStyles}</style>

                      <div style={{ maxHeight: '40vh', width: '100%', overflowY: 'scroll', marginTop: 32, marginBottom: 64 }}>
                        <List sx={{ width: '90%', bgcolor: 'background.paper' }}>


                          {filteredFriends.map((friend, index) => (
                            <div key={index}>
                              <ListItem style={{ justifyContent: 'center' }}>
                                <ListItemAvatar>
                                  <Avatar alt={friend.nameUser} src={`${friend.avatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`} />
                                </ListItemAvatar>


                                <ListItemText>
                                  <Typography
                                    sx={{ color: 'text.primary' }}
                                    style={{ fontSize: 16 }}>
                                    {friend.nameUser}
                                  </Typography>
                                </ListItemText>

                                <Checkbox
                                  checked={friend.selected || false} // Valor del Checkbox
                                  onChange={() => handleCheckboxChange(index)} // Manejador de cambios
                                />
                              </ListItem>


                              <Divider variant="fullWidth" component="li" />
                            </div>
                          ))}


                        </List>
                      </div>


                    </div>

                  ) : (
                    <div style={{ width: '100%', marginTop: 32, marginBottom: 32, justifyContent: 'center', textAlign: 'center' }}>
                      <Typography style={{ textAlign: 'center', marginBottom: 8 }}>Aún no tienes amigos, agrega amigos desde tu perfil</Typography>

                      <Button variant='outlined' style={{ marginInline: 'auto' }} onClick={() => { navigate("/perfil") }}>Ir a perfil</Button>
                    </div>
                  )}

                </>
              )}






              {/* BTN CREAR EVENTO */}
              {showAlert && (
                <Alert severity="warning">
                  Debes ingresar: {alertMsg}
                </Alert>
              )}

              <Button variant="contained"
                color='primary'
                style={{
                  marginBottom: 16,
                  width: '100%',
                  borderRadius: 40,
                  // height: 40,

                }}

                onClick={CreateNewEvent}>PUBLICAR EVENTO
              </Button>
            </div>

          </div>
        </Container >
      </div >

      <Modal
        open={openModalAddGuests}
        onClose={() => { setOpenModalAddGuests(false); navigate('/'); }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em',
          textAlign: 'center'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2" marginBottom={2}>
            Invita a más personas!
          </Typography>

          <IconButton aria-label="compartir" onClick={() => { handleShare(stateEventCreadoID) }}>
            <FaShareAlt size={24} />
          </IconButton>

          <Button variant="contained" color='success' onClick={() => { setOpenModalAddGuests(false); navigate('/'); }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
            TODO LISTO!
          </Button>
        </Box>
      </Modal>
    </div>
  )
}

export default connect(mapStateToProps)(JuntadaComun)


// Este es un formato de ejemplo. Borra o agregar lo que quieras
